import { LoadingFallback as _LoadingFallback } from "~/components/product/ProductBlogPosts"

export {
    default,
    loader,
} from "~/components/product/ProductBlogPosts"

export const LoadingFallback = _LoadingFallback
